import { useContext } from "react";
import { predictionMenuContext } from "../contexts/PredictionsMenuContext";

export function usePredictionsMenu() {

  const value = useContext(predictionMenuContext)

  return { ...value};
}
